import { CopyButton } from './CopyButton';
import { Sparkline } from './Sparkline';

const GREENHOUSE = [
  21.2, 21.0, 20.4, 20.1, 19.8, 20.2, 19.9, 19.9, 19.4, 19.2, 19.5, 19.3, 19.7,
  19.9, 20.3, 20.2, 20.6, 20.9, 20.7, 21.4, 22.1, 22.6, 22.3, 22.8, 23.1, 23.6,
  23.4, 23.9, 23.3, 23.5, 22.9, 22.8, 23.0,
];

const FREEZER = [
  -18.6, -18.3, -18.5, -18.2, -18.4, -18.3, -18.5, -18.9, -18.4, -18.6, -18.8,
  -18.7, -19.0, -18.8, -18.9, -19.2, -18.8, -19.1, -18.9, -18.4, -13.2, -12.9,
  -18.6, -19.1, -18.7, -18.5, -18.8, -18.4, -18.5, -18.2,
];

const BATTERIES = [
  { name: 'greenhouse-01', volts: '2.81V', pct: 78, bar: 'bg-green-600' },
  { name: 'barn-sensor', volts: '2.60V', pct: 72, bar: 'bg-amber-500' },
  { name: 'gateway', volts: '6.20V', pct: 100, bar: 'bg-green-600' },
];

const EXAMPLES = [
  {
    title: 'Greenhouse climate',
    value: '24.1°C',
    tone: 'text-green-600',
    prompt: 'Build a greenhouse dashboard with temperature, humidity and a 7-day trend.',
    chart: (
      <Sparkline
        data={GREENHOUSE}
        color="#16a34a"
        fill="#ecfdf3"
        fillClassName="text-[#ecfdf3] dark:text-green-950/40"
        className="h-full w-full"
      />
    ),
  },
  {
    title: 'Freezer · cold chain',
    value: '-18.4°C',
    tone: 'text-blue-600',
    prompt: 'Chart my freezer and mark every time it went above -15 °C.',
    chart: (
      <Sparkline
        data={FREEZER}
        color="#2563eb"
        fill="#e8efff"
        fillClassName="text-[#e8efff] dark:text-blue-950/40"
        threshold={-15}
        className="h-full w-full"
      />
    ),
  },
  {
    title: 'Battery health',
    value: '3 devices',
    tone: 'text-violet-600',
    prompt: 'Compare battery voltage across all my devices and flag the low ones.',
    chart: (
      <div className="flex h-full flex-col justify-center gap-3">
        {BATTERIES.map((b) => (
          <div key={b.name} className="flex items-center gap-3 text-xs">
            <span className="w-24 truncate text-gray-500 dark:text-gray-400">{b.name}</span>
            <span className="h-2 flex-1 rounded-full bg-gray-100 dark:bg-gray-700">
              <span className={`block h-2 rounded-full ${b.bar}`} style={{ width: `${b.pct}%` }} />
            </span>
            <span className="w-10 text-right font-medium text-gray-900 dark:text-gray-50">{b.volts}</span>
          </div>
        ))}
      </div>
    ),
  },
];

export function PromptGallery() {
  return (
    <section aria-labelledby="gallery-title">
      <h2 id="gallery-title" className="text-xl font-semibold text-gray-900 dark:text-gray-50">
        What people ask for
      </h2>
      <p className="mt-1 text-gray-500 dark:text-gray-400">Each of these came from a single prompt.</p>

      <ul className="mt-6 grid gap-5 md:grid-cols-3">
        {EXAMPLES.map((ex) => (
          <li
            key={ex.title}
            className="flex flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-gray-900"
          >
            <div aria-hidden="true" className="bg-[#efefeb] p-4 dark:bg-gray-800">
              <div className="rounded-xl bg-white p-4 shadow-sm dark:bg-gray-900">
                <div className="flex items-baseline justify-between gap-2">
                  <span className="text-sm font-semibold text-gray-900 dark:text-gray-50">{ex.title}</span>
                  <span className={`text-lg font-semibold ${ex.tone}`}>{ex.value}</span>
                </div>
                <div className="mt-3 h-24">{ex.chart}</div>
              </div>
            </div>
            <div className="flex flex-1 flex-col items-start gap-3 px-5 py-4">
              <p className="text-gray-900 dark:text-gray-50">&ldquo;{ex.prompt}&rdquo;</p>
              <CopyButton
                text={ex.prompt}
                label="Copy prompt"
                what={`prompt for ${ex.title}`}
                className="mt-auto"
              />
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
